<section
  class="nav-tooltip-sell"
  aria-label="Opciones de venta"
  [style.--tooltip-arrow-left-sell]="tooltipArrowPositionSell"
>
  <div class="nav-tooltip-sell__img-col">
    <img
      src="/assets/img/prueba4.svg"
      alt="Salón de piso en venta"
      class="nav-tooltip-sell__img"
    />
  </div>
  <div class="nav-tooltip-sell__content">
    <div class="nav-tooltip-sell__col">
      <h2 class="nav-tooltip-sell__title">
        {{ "components.navTooltipSell.sellWithTenantsTitle" | translate }}
      </h2>
      <p class="nav-tooltip-sell__subtitle">
        {{ "components.navTooltipSell.sellWithTenantsSubtitle" | translate }}
      </p>
      <ul class="nav-tooltip-sell__list" [ngClass]="classMb5">
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/coins.svg"
            alt="{{
              'components.navTooltipSell.sellWithTenantsList.valuation'
                | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellWithTenantsList.valuation"
              | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/lightning.svg"
            alt="{{
              'components.navTooltipSell.sellWithTenantsList.certificate'
                | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellWithTenantsList.certificate"
              | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/verified-user.svg"
            alt="{{
              'components.navTooltipSell.sellWithTenantsList.buyer' | translate
            }}"
            loading="lazy"
          />
          {{
            "components.navTooltipSell.sellWithTenantsList.buyer" | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/signature.svg"
            alt="{{
              'components.navTooltipSell.sellWithTenantsList.documentation'
                | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellWithTenantsList.documentation"
              | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item"></li>
      </ul>
      <button class="yellow-btn" (click)="goNavigateToUrl('vende')">
        <span>{{
          "components.navTooltipSell.sellWithTenantsButton" | translate
        }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
    <hr class="nav-tooltip-sell__divider" />
    <div class="nav-tooltip-sell__col">
      <h2 class="nav-tooltip-sell__title">
        {{ "components.navTooltipSell.sellBuildingsTitle" | translate }}
      </h2>
      <p class="nav-tooltip-sell__subtitle">
        {{ "components.navTooltipSell.sellBuildingsSubtitle" | translate }}
      </p>
      <ul class="nav-tooltip-sell__list mb-2">
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/bar-chart.svg"
            alt="{{
              'components.navTooltipSell.sellBuildingsList.analysis' | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellBuildingsList.analysis" | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/strategy.svg"
            alt="{{
              'components.navTooltipSell.sellBuildingsList.strategy' | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellBuildingsList.strategy" | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/handshake.svg"
            alt="{{
              'components.navTooltipSell.sellBuildingsList.management'
                | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellBuildingsList.management" | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/sell-works/building.svg"
            alt="{{
              'components.navTooltipSell.sellBuildingsList.advisory' | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellBuildingsList.advisory" | translate
          }}
        </li>
        <li class="nav-tooltip-sell__item">
          <img
            src="../../assets/icons/megaphone.svg"
            alt="{{
              'components.navTooltipSell.sellBuildingsList.confidentiality'
                | translate
            }}"
          />
          {{
            "components.navTooltipSell.sellBuildingsList.confidentiality"
              | translate
          }}
        </li>
      </ul>
      <button class="green-btn" (click)="goNavigateToUrl('buildings')">
        <span>{{
          "components.navTooltipSell.sellBuildingsButton" | translate
        }}</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</section>
